export const API_URL = 'http://localhost:3000';
export const IS_AUTHENTICATED = 'authenticated';
export const ACCESS_TOKEN = 'accessToken';
export const USER = 'user';
export const ROLE = 'role';
export const STUDENT = 'Student';
export const MENTOR = 'Mentor';
export const ADMIN = 'Admin';
